import React from 'react';
import { GiftIcon } from 'lucide-react';
import { formatPrice } from '../data/config';
import { CheckItem } from './CheckItem';
type Group = {
  label: string;
  text: string;
};
type BonusCardProps = {
  number: string;
  title: string;
  collection?: string;
  subtitle: string;
  price: number;
  intro: string[];
  list?: string[];
  groups?: Group[];
  outro?: string[];
  finalLine: string;
  meta?: string;
  showReferencePrice: boolean;
};
export function BonusCard({
  number,
  title,
  collection,
  subtitle,
  price,
  intro,
  list,
  groups,
  outro,
  finalLine,
  meta,
  showReferencePrice
}: BonusCardProps) {
  return <article className="rounded-md border-l-[5px] border-amber-400 bg-white px-3.5 py-3 text-left md:px-4 md:py-3.5" data-id="element-17" data-mp="29dus36rsxfr5">
      <h3 className="flex items-start gap-2 text-[14px] font-extrabold uppercase leading-tight text-blue-950 md:text-[15px]" data-id="element-18" data-mp="2e7p8o1c41em0">
        <GiftIcon className="mt-px h-4 w-4 shrink-0 text-amber-600" strokeWidth={2.5} aria-hidden data-id="element-19" data-mp="1lpbgoidggmuu" />
        <span data-id="element-20" data-mp="1x1v4amlal4tb">
          Bonus {number} — {title}
        </span>
      </h3>
      {collection && <p className="mt-1 pl-6 text-[12px] font-extrabold uppercase leading-tight text-blue-950/80 md:text-[13px]" data-id="element-21" data-mp="1s2i8vdgcupf4">
          {collection}
        </p>}
      <p className="mt-1 text-[12px] font-bold leading-snug text-teal-700 md:text-[13px]" data-id="element-22" data-mp="1na8n89m9wbin">{subtitle}</p>
      <p className="mt-0.5 flex flex-wrap items-center gap-2 text-[11px] font-extrabold uppercase md:text-[12px]" data-id="element-23" data-mp="1ib4e1izcmdsb">
        {showReferencePrice && <span className="font-semibold text-slate-500" data-id="element-24" data-mp="19cak60dek1ig">
            Reference value: <s data-id="element-25" data-mp="14d7eqetift9y">{formatPrice(price)} USD</s>
          </span>}
        <span className="text-green-600" data-id="element-26" data-mp="14fjvwprg1zly">Free with your purchase</span>
      </p>
      <div className="mt-1.5 space-y-1 text-[14px] leading-[1.4] text-slate-600 md:text-[15px]" data-id="element-27" data-mp="zfxjujncqpeq">
        {intro.map(p => <p key={p} data-id="element-28" data-mp="2yp4dksua81f1">{p}</p>)}
      </div>
      {list && <ul className="mt-1.5 space-y-0.5 text-[14px] leading-[1.4] text-slate-600 md:text-[15px]" data-id="element-29" data-mp="2tsx4wsai4bte">
          {list.map(item => <CheckItem key={item} data-id="element-30" data-mp="s1dik40imhqv">{item}</CheckItem>)}
        </ul>}
      {groups && <dl className="mt-2 space-y-1.5 text-[14px] leading-[1.4] md:text-[15px]" data-id="element-31" data-mp="i522d2xt17r5">
          {groups.map(g => <div key={g.label} data-id="element-32" data-mp="n3lob3ceejji">
              <dt className="text-[12px] font-extrabold uppercase text-blue-950 md:text-[13px]" data-id="element-33" data-mp="n4wu18pem1d9">{g.label}</dt>
              <dd className="text-slate-600" data-id="element-34" data-mp="1au8xrt1yph86">{g.text}</dd>
            </div>)}
        </dl>}
      {outro && <div className="mt-1.5 space-y-1 text-[14px] leading-[1.4] text-slate-600 md:text-[15px]" data-id="element-35" data-mp="1fqg7zy1e5evx">
          {outro.map(p => <p key={p} data-id="element-36" data-mp="15u3ccumacqyj">{p}</p>)}
        </div>}
      <p className="mt-2 text-[12px] font-extrabold uppercase leading-tight text-amber-700 md:text-[13px]" data-id="element-37" data-mp="15wphyopm8we4">
        {finalLine}
      </p>
      {meta && <p className="mt-1 text-[12px] font-semibold text-slate-500 md:text-[13px]" data-id="element-38" data-mp="3ql3tt44p7egr">{meta}</p>}
    </article>;
}